<template>
  <div
    class="letsGoPopupContainer flexContainer yCenterContainer columnContainer"
  >
    <button
      @click="closePopup"
      class="closeButton mediumText"
      style="color: #000000"
    >
      x
    </button>
    <p class="mediumText">
      Wademekum powstaje, żebyśmy mogli odnaleźć się w krajobrazie mentalnym.
      Wspaniale, prawda?
    </p>
    <p class="smallText">
      Klauzula o inteligencji i odpowiedzialności:<br />
      Zwiedzając Przewodnik po krajobrazie mentalnym, przyznajesz, że jesteś
      inteligentną istotą, a co za tym idzie, ponosisz odpowiedzialność nie
      tylko za to co dajesz, ale również za to co bierzesz do siebie.
    </p>
    <router-link
      :to="randomArticlePath"
      @click.native="closePopup"
      class="mediumText"
      >Wspaniale!</router-link
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      randomArticleId: null,
      randomArticleTitle: null,
    };
  },
  methods: {
    closePopup() {
      this.$store.dispatch("deletePopupMessage");
    },
  },
  computed: {
    randomArticlePath() {
      return this.randomArticleTitle + "-" + this.randomArticleId;
    },
  },
  created() {
    this.$http.get("random/").then(
      (response) => {
        this.randomArticleId = response.data.id;
        this.randomArticleTitle = response.data.title;
      },
      (error) => {
        console.log(error);
      }
    );
  },
};
</script>

<style scoped>
.letsGoPopupContainer {
  justify-content: space-between;
  width: 25%;
  height: 30%;
  margin-top: 17%;
  margin-left: 23%;
  border: 2px solid #1e6788;
  background-color: #ffffff;
  padding: 2%;
  box-shadow: 0 0 0 4px #ffffff, 0 0 0 6px #000000;
}

p {
  width: 90%;
  margin: 2%;
}

a {
  align-self: center;
  color: #ec783e;
}

@media (max-width: 1000px) {
  .letsGoPopupContainer {
    margin-top: 17%;
    margin-left: 10%;
    width: 70%;
    height: 50%;
  }
}
</style>
